"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillKeywordDataWithDefaultValues = void 0;
const enums_1 = require("./enums");
const root_1 = require("../root");
function fillKeywordDataWithDefaultValues(keywordData, featureFlags, ownership) {
    const keywordDataCopy = { ...keywordData };
    const documentSearchEnabled = featureFlags.includes(root_1.FeatureFlag.MatchingProfile_BroadOrNarrowSearchInDocuments);
    if (!keywordDataCopy.searchType) {
        keywordDataCopy.searchType = documentSearchEnabled ? enums_1.SearchType.NoticeAndDocument : enums_1.SearchType.Notice;
    }
    if (!keywordDataCopy.filterLogic) {
        // other ownerships will use default behaviour until specified otherwise
        const isBfWithDocumentSearch = ownership === root_1.UserOwnership.Byggfakta && documentSearchEnabled;
        keywordDataCopy.filterLogic = isBfWithDocumentSearch ? enums_1.FilterLogic.NarrowSearch : enums_1.FilterLogic.BroadSearch;
    }
    if (!keywordDataCopy.searchLogic)
        keywordDataCopy.searchLogic = enums_1.SearchLogic.ExactMatch;
    if (!keywordDataCopy.highlightColor)
        keywordDataCopy.highlightColor = enums_1.HighlightColor.Yellow;
    return keywordDataCopy;
}
exports.fillKeywordDataWithDefaultValues = fillKeywordDataWithDefaultValues;
